import React, { useEffect } from 'react';
import { Button, Divider, Form, Input } from 'antd';
import { GoogleLogin } from 'react-google-login';
import { useTranslation } from 'react-i18next';
import { handleGAEvent } from '../../helperFunctions';
import { GACategories, GAActions } from '../../analytics';
import styles from './InviteContainer.scss';

const EmailForm = ({ email_id, onRequestOTP, onGoogleResponse }) => {
  const { t } = useTranslation('auth');
  const [form] = Form.useForm();
  /*
The issue was that Ant Design's initialValues 
only sets the value on first render. 
When the invite data loads asynchronously, the form field wasn't updating. 
Now the form will dynamically update when the invite email becomes available!
*/
  useEffect(() => {
    if (email_id) {
      form.setFieldsValue({ email: email_id });
    }
  }, [email_id, form]);

  return (
    <div className={styles['c-invite__email']}>
      <Form
        form={form}
        onFinish={onRequestOTP}
        variant="filled"
        initialValues={{ email: email_id }}
        validateMessages={{
          required: t('email_form.validation.required'),
          types: { email: t('email_form.validation.invalid_email') },
        }}
      >
        <Form.Item
          name="email"
          rules={[{ required: true, type: 'email' }]}
        >
          <Input
            style={{ borderRadius: 2 }}
            placeholder={t('email_form.placeholder.email')}
          />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          style={{ width: '100%', height: '40px', borderRadius: 2 }}
        >
          {t('email_form.request_otp')}
        </Button>
      </Form>

      <Divider
        plain
        style={{ borderColor: '#D9D9D9' }}
      >
        {t('email_form.or_login_with')}
      </Divider>

      <GoogleLogin
        clientId="73660977592-m50kcgualicen86vokvsbg3vsh8h6c2e.apps.googleusercontent.com"
        buttonText={t('email_form.google_sign_in')}
        responseType="code"
        onSuccess={handleGAEvent(onGoogleResponse, GACategories.auth, GAActions.googleLogin)}
        onFailure={onGoogleResponse}
      />
    </div>
  );
};

export default EmailForm;
